export enum OrderItemType {
    STORABLE_PRODUCT = 'storable_product',
    SERVICE = 'service',
    CONSUMABLE_PRODUCT = 'consumable_product'
}
